import erc20Abi from "./abis/erc20.json";
import ownableAbi from "./abis/ownable.json";

const abis = {
  erc20: erc20Abi,
  ownable: ownableAbi,
};

export default abis;
